// extracted by mini-css-extract-plugin
module.exports = {"PlaceholderAvatar":"styles_PlaceholderAvatar__1oY-i"};